import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contains'
})
export class ContainsPipe implements PipeTransform {

  transform(arr: any[], searchFor: string, searchIn?: string[]): any[] {
    if (!searchFor) {
      return arr;
    }
    searchFor = searchFor.toUpperCase();
    let value = '';
    const firstValue = (arr || [])[0];

    const isObject = typeof firstValue === 'object';
    const isString = typeof firstValue === 'string';

    const filteredArray = (arr || []).filter(element => {
      if (isString) {
        return element.toUpperCase().indexOf(searchFor) > -1;
      } else if (isObject) {
        for (let i = 0; i < searchIn.length; i++) {
          const searchText = searchIn[i];

          if (searchText.indexOf('.') > -1) {
            const searchSplit = searchText.split('.');
            value = element[searchSplit[0]][searchSplit[1]];
          } else {
            value = element[searchText];
          }

          if (!!value && value.toString().toUpperCase().indexOf(searchFor) > -1) {
            return true;
          }
        }
      }

    });

    return filteredArray;
  }

}

@NgModule({
  imports: [],
  declarations: [ContainsPipe],
  exports: [ContainsPipe]
})
export class ContainsPipeModule { }
